// ColumnHeightAdjuster.js

class ColumnHeightAdjuster {
    constructor() {
        // Select the right and left columns
        this.rightColumn = document.querySelector('.column-2');
        this.leftCoverBlock = document.querySelector('.column-cover');

        // If elements exist, adjust their height initially
        if (this.rightColumn && this.leftCoverBlock) {
            this.adjustHeight();
            // Adjust height on window resize
            window.addEventListener('resize', this.adjustHeight.bind(this));
        }
    }

    adjustHeight() {
        // Only adjust height if the screen width is 782px or more
        if (window.innerWidth >= 782) {
            const rightHeight = this.rightColumn.offsetHeight;
            this.leftCoverBlock.style.height = `${rightHeight}px`;
        } else {
            // Reset height to default if screen width is less than 782px
            this.leftCoverBlock.style.height = 'auto';
        }
    }
}

export default ColumnHeightAdjuster;